import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import {
  ManagementEntrySummaryManualStateModel,
  ManagementEntrySummaryModel,
  ManagementEntrySummarySearchModel,
  ManagementEntrySummaryShortModel,
  ManagementEventModel,
} from '@data-layer/models/management';
import { PaginatedResultModel, PaginationSearchModel } from '@data-layer/models/common';
import { enumEntrySummaryDutiesPaymentType } from '@data-layer/enums/entry-summaries';

@Injectable({
  providedIn: 'root',
})
export class EntrySummaryManagementRepository {
  constructor(private apiService: ApiService) {}

  public search(
    params: ManagementEntrySummarySearchModel,
    isShowLoader: boolean = true,
  ): Observable<PaginatedResultModel<ManagementEntrySummaryShortModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementEntrySummaryShortModel>>(
      `${environment.url.esManagement}`,
      { params },
      { isShowLoader },
    );
  }

  public get(id: number): Observable<ManagementEntrySummaryModel> {
    return this.apiService.get<ManagementEntrySummaryModel>(`${environment.url.esManagement}${id}`);
  }

  public getByRefNumber(referenceNumber: string): Observable<ManagementEntrySummaryModel> {
    return this.apiService.get<ManagementEntrySummaryModel>(`${environment.url.esManagement}details?referenceNumber=${referenceNumber}`);
  }

  public setState(id: number, state: ManagementEntrySummaryManualStateModel): Observable<never> {
    return this.apiService.put(`${environment.url.esManagement}${id}/state`, state);
  }

  public setAsReleased(id: number): Observable<string> {
    return this.apiService.post(`${environment.url.esManagement}released`, null, {
      params: {
        id,
      },
    });
  }

  public getEvents(
    id: number,
    params: PaginationSearchModel,
    isShowLoader: boolean = false,
  ): Observable<PaginatedResultModel<ManagementEventModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementEventModel>>(
      `${environment.url.esManagement}${id}/events`,
      { params },
      { isShowLoader },
    );
  }

  public resetProviderEvent(esId: number, eventId: number): Observable<void> {
    return this.apiService.put<void>(`${environment.url.esManagement}${esId}/last-event-id`, eventId);
  }

  public changeDutiesPaymentType(esId: number, type: enumEntrySummaryDutiesPaymentType): Observable<void> {
    return this.apiService.put<void>(`${environment.url.esManagement}${esId}/duties-payment-type`, type);
  }
}
